import React, { PureComponent } from "react";

import styles from "./SocialLarge.local.scss";
import classnames from "classnames";

import _ from "i18n";

export default class SocialLargeComponent extends PureComponent {
  render() {
    const {
      resource,
      onClickLike,
      countDislike,
      countLike,
      onClickFav
    } = this.props;
    const { countComments, social } = resource;

    return (
      <div className={styles.socialContent}>
        <ul className={styles.socialData}>
          <li>
            <i className="icon icon-like" />
            <span>{countLike ? countLike : 0}</span>
          </li>
          <li>
            <i className="icon icon-dislike" />
            <span>{countDislike ? countDislike : 0}</span>
          </li>
          <li>
            <i className="icon icon-bubble" />
            <span>
              {countComments ? countComments : 0} {_("Comments")}
            </span>
          </li>
        </ul>
        <ul className={styles.social}>
          <li
            className={classnames(
              styles.socialAction,
              styles.like,
              styles.socialLike,
              social.isLiked && social.isLiked === 1 ? styles.socialActive : ""
            )}
            onClick={onClickLike.bind(this, true, true)}
          >
            <i className="icon icon-like" />
            <span>{_("Like")}</span>
          </li>
          <li
            className={classnames(
              styles.socialAction,
              styles.dislike,
              styles.socialLike,
              social.isLiked !== undefined && social.isLiked === 0
                ? styles.socialActive
                : ""
            )}
            onClick={onClickLike.bind(this, false, true)}
          >
            <i className="icon icon-dislike" />
            <span>{_("I don't like")}</span>
          </li>
          <li>
            <i className="icon icon-share" />
            <span>{_("Share")}</span>
          </li>
          <li
            className={classnames(
              styles.socialAction,
              social.isFavorite && social.isFavorite === 1
                ? styles.socialActive
                : ""
            )}
            onClick={onClickFav.bind(this, true)}
          >
            <i className="icon icon-star" />
            <span>{_("Favoris")}</span>
          </li>
        </ul>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Social/SocialLargeComponent.js